<template>
  <div class="page-body">
    <PageTitle title="Canteen Headcount" />

    <!-- Summary -->

   

    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <!-- Header -->

          <div
            class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-1"
          >
            <ul class="nav nav-tabs border-0">
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{active:activeTab=='list'}"
                  @click="activeTab='list'"
                >
                  Headcount List
                </a>
              </li>

              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{active:activeTab=='create'}"
                  @click="activeTab='create'"
                >
                  Create Headcount
                </a>
              </li>
            </ul>
          </div>

          <!-- LIST -->

          <div v-if="activeTab=='list'">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th v-if="sd==user?.empdept">Prepared By</th>
                    <th v-if="sd==user?.empdept">Department</th>
                    <th>Type</th>
                    <th>Total</th> 
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="item in headcounts" :key="item.id">
                    <td>{{ item.headcount_date }}</td>
                    <td v-if="sd==user?.empdept">{{ item.prepared_by }}</td>
                    <td v-if="sd==user?.empdept">{{ item.deptname }}</td>
                    <td>{{ item.type }}</td>
                    <td>{{ item.total_headcount }}</td>
 
                    <td>
                      <button
                        class="btn btn-sm btn-primary"
                        @click="editItem(item)"
                      >
                        Edit
                      </button>
                        <button v-if="sd==user?.empdept"
                        class="btn btn-sm btn-danger"
                        @click="deleteHeadcount(item.id)"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- CREATE -->

          <div v-if="activeTab=='create'">
            <!-- Basic Information -->

            <div class="custom-section">
             

              <div class="row">
                  <div class=" ">
                      <h5 class="mb-0">{{user.empname}}</h5> 
                      <b>{{user.dept_name}}</b>
                      
                  </div>
                

                <div class="col-md-6 mb-1">
                  <label>Date *</label>

                  <input type="date" class="form-control" v-model="form.date"   @change="checkExistingHeadcount" />
                </div>

                <div class="col-md-6 mb-1">
                  <label>Type *</label>

                  <select class="form-control" v-model="form.type"> 
                    <option>Sunday</option>
                    <option>Holiday</option>
                  </select>
                </div>

               
                <div class="col-md-6">
                  <label>Contact Number</label> 
                  <input class="form-control" v-model="user.contact" />
                </div>
              </div>
            </div>

            <!-- Headcount Table -->

            <div  >
              <h5> Shift Wise Headcount</h5>

            <div class="headcount-table-wrapper">
                    <table class="table table-bordered mb-0">
                        <thead>
                            <tr>
                                <th class="sticky-col">Category</th>
                                <th>1st</th>
                                <th>Gnrl</th>
                                <th>2nd</th>
                                <th>3rd</th>
                                <th>OT</th>
                            </tr>
                        </thead>
                
                        <tbody>
                            <tr v-for="item in categories" :key="item.category">
                                <td class="sticky-col">
                                    {{ item.category }}
                                </td>
                
                                <td>
                                    <input type="number"
                                           class="form-control"
                                           @focus="$event.target.select()"
                                           v-model.number="item.shift1">
                                </td>
                
                                <td>
                                    <input type="number"
                                           class="form-control"
                                           @focus="$event.target.select()"
                                           v-model.number="item.general">
                                </td>
                
                                <td>
                                    <input type="number"
                                           class="form-control"
                                           @focus="$event.target.select()"
                                           v-model.number="item.shift2">
                                </td>
                
                                <td>
                                    <input type="number"
                                           class="form-control"
                                           @focus="$event.target.select()"
                                           v-model.number="item.shift3">
                                </td>
                                <td>
                                    <input type="number"
                                           class="form-control"
                                           @focus="$event.target.select()"
                                           v-model.number="item.ot">
                                </td>
                            </tr>
                
                            <tr class="fw-bold bg-light">
                                <td class="sticky-col">Total</td>
                
                                <td>{{ totalShift1 }}</td>
                                <td>{{ totalGeneral }}</td>
                                <td>{{ totalShift2 }}</td>
                                <td>{{ totalShift3 }}</td>
                                <td>{{ totalOt }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- OT -->

            <div  >
              <h5> Total Headcount</h5>

              <div class="row">
                <div class="col-md-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="totalHeadcount"
                    placeholder="Total OT Headcount" readonly=""
                  />
                </div>
              </div>
            </div>

            <!-- Remarks -->

            <div  >
              <h5>  Remarks</h5>

              <textarea
                rows="4"
                class="form-control"
                v-model="form.remarks"
              ></textarea>
            </div>

            <!-- Buttons -->

            <div class="d-flex justify-content-end gap-2 mt-4 flex-wrap">
              <button class="btn btn-outline-secondary" @click="clearForm">
                Clear
              </button>

              <!--<button class="btn btn-outline-primary" @click="saveDraft">-->
              <!--  Save Draft-->
              <!--</button>-->

              <button class="btn btn-primary" @click="submitForm">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
label{
    margin-bottom: 0;
}
    .custom-section{
border:1px solid #e4e4e4;
border-radius:12px;
padding:5px;
margin-bottom:20px;
background:#fff;
}

.custom-section h5{
color:#003399;
font-weight:600;
margin-bottom:20px;
}

.form-control{
min-height:42px;
}

.table th{
background:#003399;
color:#fff;
vertical-align:middle;
}

.action{
display:flex;
gap:20px;
list-style:none;
padding:0;
margin:0;
}
.active{
    background: var(--bs-primary-text-emphasis)!important;
    color: white!important;
}
 
.headcount-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.headcount-table-wrapper table {
    min-width: 260px;
    table-layout: fixed;
}

/* Category Column */
.sticky-col {
    position: sticky;
    left: 0;
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    background: #fff;
    z-index: 2;
    font-size: 12px;
    font-weight: 600;
    word-break: break-word;
    white-space: normal;
}

/* Shift Columns */
.headcount-table-wrapper th:not(.sticky-col),
.headcount-table-wrapper td:not(.sticky-col) {
    width: 50px;
    min-width: 50px;
    max-width: 50px;
    text-align: center;
    padding: 4px;
}

.headcount-table-wrapper input.form-control {
    width: 100%;
    min-width: 40px;
    padding: 2px;
    text-align: center;
    font-size: 12px;
}

thead .sticky-col {
    background: #003399;
    color: #fff;
    z-index: 3;
}
td input{
       font-weight: 700;
    font-size: medium !important;
}
</style>
<script>
  // @ is an alias to /src 
  import PageTitle from '@/components/PageTitle.vue'; 
  // import axios from 'axios';
  import axios from "@/plugins/axios";
  
  
 export default {
    name: 'HeadCount',
    components: {
      PageTitle, 
    },
      data() {
  return {
    sd:0,
  activeTab:'list',

  headcounts:[],

  departments:[],

  form:{
  department_id:'',
  date:'',
  type:'Sunday',
  prepared_by:'',
  contact:'',
  ot_headcount:0,
  remarks:''
  },

  categories:[
  {
  category:'Staff',
  shift1:0,
  general:0,
  shift2:0,
  shift3:0,
  ot:0
  },
  {
  category:'On-roll Workers',
  shift1:0,
  general:0,
  shift2:0,
  shift3:0,
  ot:0
  },
  {
  category:'DETs / NAPS',
  shift1:0,
  general:0,
  shift2:0,
  shift3:0,
  ot:0
  },
  {
  category:'Contract Labour',
  shift1:0,
  general:0,
  shift2:0,
  shift3:0,
  ot:0
  },
  {
  category:'Job Contract',
  shift1:0,
  general:0,
  shift2:0,
  shift3:0,
  ot:0
  },
  {
  category:'Plant Maintenance',
  shift1:0,
  general:0,
  shift2:0,
  shift3:0,
  ot:0
  },
  {
  category:'Visitors / Vendor',
  shift1:0,
  general:0,
  shift2:0,
  shift3:0,
  ot:0
  }
  ]

  }
 
  },
   mounted() {
    this.getBasics();
    },
   computed:{

        totalShift1(){
        return this.categories.reduce((a,b)=>a+Number(b.shift1||0),0)
        },
        
        totalGeneral(){
        return this.categories.reduce((a,b)=>a+Number(b.general||0),0)
        },
        
        totalShift2(){
        return this.categories.reduce((a,b)=>a+Number(b.shift2||0),0)
        },
        
        totalShift3(){
        return this.categories.reduce((a,b)=>a+Number(b.shift3||0),0)
        },
        totalOt(){
        return this.categories.reduce((a,b)=>a+Number(b.ot||0),0)
        },
       totalHeadcount() {
                return this.totalShift1 +
                       this.totalGeneral +
                       this.totalShift2 +
                       this.totalShift3+
                       this.totalOt;
            }
        
        },
         methods: {
                clearForm() {
                this.form = {
                    id: '',
                    department_id: '',
                    date: '',
                    type: 'Sunday',
                    prepared_by_id: '',
                    contact: '',
                    remarks: ''
                };
        
                this.categories = [
                    {
                        category:'Staff',
                        shift1:0,
                        general:0,
                        shift2:0,
                        shift3:0,
                        ot:0
                    },
                    {
                        category:'On-roll Workers',
                        shift1:0,
                        general:0,
                        shift2:0,
                        shift3:0,
                        ot:0
                    },
                    {
                        category:'DETs / NAPS',
                        shift1:0,
                        general:0,
                        shift2:0,
                        shift3:0,
                        ot:0
                    },
                    {
                        category:'Contract Labour',
                        shift1:0,
                        general:0,
                        shift2:0,
                        shift3:0,
                        ot:0
                    },
                    {
                        category:'Job Contract',
                        shift1:0,
                        general:0,
                        shift2:0,
                        shift3:0,
                        ot:0
                    },
                    {
                        category:'Plant Maintenance',
                        shift1:0,
                        general:0,
                        shift2:0,
                        shift3:0,
                        ot:0
                    },
                    {
                        category:'Visitors / Vendor',
                        shift1:0,
                        general:0,
                        shift2:0,
                        shift3:0,
                        ot:0
                    }
                ];
            },
             getBasics() {
                    let self = this;
                
                    axios.post('getHeadcountBasics').then(function(response){
                
                        self.headcounts = response.data.headcounts;
                        self.departments = response.data.departments;
                        self.user = response.data.employee;
                        self.sd = response.data.sd;
                
                    });
                },
                submitForm() {
                    let self=this;
                        if(!self.user)
                            return;
                    
                        if(!self.form?.date)
                            {
                                 self.$swal("Please Select Date");
                                 return;
                            }
                             if(self.totalHeadcount<=0)
                            {
                                 self.$swal("Please Add Head Count");
                                 return;
                            }
                            
                        self.form.prepared_by_id=self.user.id;
                        self.form.prepared_by=self.user.empname;
                        self.form.department_id=self.user.empdept;
                        self.form.contact=self.user.contact;
                        self.form.ot_headcount=self.totalHeadcount; 
                        
                        let payload = {
                            form: self.form,
                            categories: self.categories
                        };
                    
                     
                    
                        axios.post('saveHeadcount', payload)
                        .then(function(response){
                    
                            self.$swal(response.data.msg);
                    
                            if(response.data.status == 1){
                    
                                self.headcounts = response.data.headcounts;
                    
                                self.clearForm();
                    
                                self.activeTab = 'list';
                            }
                    
                        });
                    
                    },
                    
                    deleteHeadcount(id){

                    let self = this;
                
                    self.$swal({
                        title:"Delete Headcount ?",
                        icon:"warning",
                        showCancelButton:true
                    })
                    .then((result)=>{
                
                        if(result.isConfirmed){
                
                            axios.post('deleteHeadcount',{
                                id:id
                            })
                            .then(function(response){
                
                                self.headcounts =
                                response.data.headcounts;
                
                            });
                
                        }
                
                    });
                
                },
                   editItem(item){
                        axios.post('getHeadcountDetails',{
                            id:item.id
                        }).then((response)=>{
                    
                            this.form = response.data.header;
                            this.categories = response.data.details;
                    
                            this.activeTab='create';
                        });
                    },
                    async checkExistingHeadcount()
                    {
                        if (!this.form.date) {
                            return;
                        }
                    
                        const existing = this.headcounts.find(
                            item => item.headcount_date === this.form.date
                        );
                    
                        if (!existing) {
                            return;
                        }
                    
                        const result = await this.$swal({
                            title: 'Headcount Already Exists',
                            text: 'Data already exists for this date. Load and update existing record?',
                            icon: 'warning',
                            showDenyButton: true,
                            showCancelButton: true,
                    
                            confirmButtonText: 'Yes',
                            denyButtonText: 'No',
                            cancelButtonText: 'Cancel'
                        });
                    
                        if (result.isConfirmed) {
                    
                            this.editItem(existing);
                    
                        }
                        else {
                    
                            this.form.date = '';
                    
                        }
                    }

         }
 }
</script>
